import { render, staticRenderFns } from "./TableHierarchyTree.vue?vue&type=template&id=3627c8d0&scoped=true&"
import script from "./TableHierarchyTree.vue?vue&type=script&lang=js&"
export * from "./TableHierarchyTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3627c8d0",
  null
  
)

export default component.exports